

















import { Component, Vue, Prop } from "vue-property-decorator"
import VideoOnVideo from "../components/layouts/VideoOnVideoLayout.vue"
import MockVovDataService from "../services/MockVovDataService"
import VideoOnVideoInfo from "../models/VideoOnVideoInfo"
@Component({ components: { VideoOnVideo } })
export default class AmplilyWidget extends Vue {
  data() {
    return {
      moments: undefined
    }
  }

  public mounted() {
    this.$data.moments = MockVovDataService() as VideoOnVideoInfo[]
  }
}
